<template>
  <div class="card">
    <div class="card-header">
      <h2>Basic Information</h2>
    </div>
    <div class="card-body">
      <div class="form-grid">
        <div class="form-field">
          <label for="title">Course Title (English) <span class="required">*</span></label>
          <input 
            id="title"
            :value="modelValue.title"
            @input="updateField('title', $event.target.value)"
            type="text"
            required
            placeholder="Enter course title"
          >
        </div>
        
        <div class="form-field">
          <label for="title_ar">Course Title (Arabic) <span class="required">*</span></label>
          <input 
            id="title_ar"
            :value="modelValue.title_ar"
            @input="updateField('title_ar', $event.target.value)"
            type="text"
            placeholder="Enter Arabic course title"
            dir="rtl"
          >
        </div>

        <div class="form-field">
          <label for="instructor">Instructor</label>
          <select 
            id="instructor"
            :value="modelValue.instructor_id"
            @change="updateField('instructor_id', $event.target.value)"
          >
            <option value="">Select Instructor</option>
            <option 
              v-for="instructor in instructors" 
              :key="instructor.id" 
              :value="instructor.user_id"
            >
              {{ instructor.display_name }}
            </option>
          </select>
        </div>
        
        <div class="form-field">
          <label for="category">Category <span class="required">*</span></label>
          <select 
            id="category"
            :value="modelValue.category_id"
            @change="updateField('category_id', $event.target.value)"
            required
          >
            <option value="">Select Category</option>
            <option 
              v-for="category in categories" 
              :key="category.id" 
              :value="category.id"
            >
              {{ category.name }} {{ category.title_ar ? `- ${category.title_ar}` : '' }}
            </option>
          </select>
        </div>

        <div class="form-field">
          <label for="minutes">Duration (minutes)</label>
          <input 
            id="minutes"
            :value="modelValue.minutes"
            @input="updateField('minutes', $event.target.value)"
            type="number"
            min="0"
            placeholder="Enter duration in minutes"
          >
        </div>
        
        <div class="form-field">
          <label for="status">Status <span class="required">*</span></label>
          <select 
            id="status"
            :value="modelValue.status"
            @change="updateField('status', $event.target.value)"
            required
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="draft">Draft</option>
          </select>
        </div>

        <div class="form-field">
          <label for="price">Price ($)</label>
          <input 
            id="price"
            :value="modelValue.price"
            @input="updateField('price', $event.target.value)"
            type="number"
            step="0.01"
            min="0"
            placeholder="Enter price (optional)"
          >
        </div>
        
        <div class="form-field">
          <label for="thumbnail">Thumbnail URL</label>
          <input 
            id="thumbnail"
            :value="modelValue.thumbnail"
            @input="updateField('thumbnail', $event.target.value)"
            type="url"
            placeholder="Enter thumbnail URL"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInformationCard',
  props: {
    modelValue: {
      type: Object,
      required: true
    },
    instructors: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  emits: ['update:modelValue'],
  methods: {
    updateField(field, value) {
      this.$emit('update:modelValue', {
        ...this.modelValue,
        [field]: value
      });
    }
  }
};
</script>

<style scoped>
.card {
  background-color: white;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}

.card:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.07);
}

.card-header {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.card-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1e293b;
}

.card-body {
  padding: 1.5rem;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem;
}

.form-field {
  display: flex;
  flex-direction: column;
}

.form-field label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563;
  margin-bottom: 0.5rem;
}

.required {
  color: #ef4444;
  margin-left: 2px;
}

.form-field input,
.form-field select {
  height: 2.75rem;
  padding: 0 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background-color: white;
  font-size: 0.875rem;
  color: #1e293b;
  transition: all 0.2s ease;
}

.form-field input:focus,
.form-field select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.form-field input:hover,
.form-field select:hover {
  border-color: #9ca3af;
}

.form-field input[dir="rtl"] {
  text-align: right;
  font-family: 'Noto Sans Arabic', system-ui, -apple-system, sans-serif;
}
</style> 